











import Vue from 'vue';

export default Vue.extend({
  name: 'HToast',
  props: {
    text: {
      type: String,
      required: true,
    },
    multiLine: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'success',
    },
  },
  data() {
    return {
      model: false,
    };
  },
  methods: {
    show() {
      this.model = true;
    },
    hide() {
      this.model = false;
    },
  },
});
